import { Button, type ButtonProps, Popover, type PopoverProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import type React from "react";

const BUTTON_PREFIX = "MenuPopoverButton";
export const buttonClasses: Record<string, string> = {
  filter: `${BUTTON_PREFIX}-filter`,
  action: `${BUTTON_PREFIX}-action`,
  sort: `${BUTTON_PREFIX}-sort`,
};

interface IMenuPopoverButtonProps extends ButtonProps {
  open: boolean;
}
export const MenuPopoverButton = styled<React.FC<IMenuPopoverButtonProps>>(Button, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  [`&.${buttonClasses.filter}`]: {
    backgroundColor: "white",
    textTransform: "none",
    borderWidth: "1px",
    borderColor: open ? "#E3E5EE" : "unset",
    borderBottomColor: open ? "white" : "unset",
    height: "32px",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  [`&.${buttonClasses.action}`]: {
    fontSize: "0.8125rem",
    lineHeight: 1,
    letterSpacing: "1.25px",
    height: "32px",
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  },
  [`&.${buttonClasses.sort}`]: {
    backgroundColor: "white",
    textTransform: "none",
    borderWidth: "1px",
    borderColor: open ? "#E3E5EE" : "unset",
    borderBottomColor: open ? "white" : "unset",
    height: "32px",
    "&:hover": {
      backgroundColor: "unset",
    },
  },
}));

const POPOVER_PREFIX = "MenuPopoverContainer";
export const popoverClasses = {
  root: `${POPOVER_PREFIX}-root`,
  filter: `${POPOVER_PREFIX}-filter`,
  action: `${POPOVER_PREFIX}-action`,
  sort: `${POPOVER_PREFIX}-sort`,
} as const;

interface IMenuPopoverContainerProps extends PopoverProps {
  minWidth?: number;
}
export const MenuPopoverContainer = styled<React.FC<IMenuPopoverContainerProps>>(Popover, {
  shouldForwardProp: (prop) => prop !== "minWidth",
})(({ theme, minWidth }) => ({
  [`&.${popoverClasses.root}`]: {
    "& .MuiPopover-paper": {
      maxHeight: "300px",
      minWidth: minWidth ? minWidth : "unset",
      boxSizing: "border-box",
    },
    [`&.${popoverClasses.filter}`]: {
      "& .MuiPopover-paper": {
        padding: theme.spacing(1),
      },
    },
    [`&.${popoverClasses.action}`]: {
      "& .MuiPopover-paper": {
        padding: `${theme.spacing(1)} 0`,
      },
    },
    [`&.${popoverClasses.sort}`]: {
      "& .MuiPopover-paper": {
        padding: "12px 0",
      },
    },
  },
}));
